<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Plan Lead List</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-2">
                        <mat-select placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')">
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option>All</mat-option>
                            <mat-option [value]="cir.id" *ngFor="let cir of circles">{{cir.name}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2">
                        <mat-select placeholder="Lead Source" [(ngModel)]="lead_source" multiple>
                            <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">
                                {{lsources.source_name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2">
                        <mat-select placeholder="Package Type" [(ngModel)]="pkg_type" multiple>
                            <mat-option value="{{ptype.id}}" *ngFor="let ptype of package_type">{{ptype.plan_name}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2">
                        <input class="form-control" type="text" [(ngModel)]="search" placeholder="Search" />
                    </div>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadPlanList(0,perpage)">
                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                            class="fa fa-sync"></i> Reset Filters</button>

                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadPlanList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                    <button type="button" class="btn btn-success ml-2" [disabled]="loading"
                        (click)="exportPlanList()"><i class="fa fa-file-excel"></i> Export List</button>

                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Circle</th>
                            <th>City</th>
                            <th>Lead Source</th>
                            <th>Type</th>
                            <th>Package Type</th>
                            <th>Lead Status</th>
                            <th>Description</th>
                            <th>Created Date</th>
                            <th style="width: 100px;">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let plan of planList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{plan.name}} </td>
                            <td>{{plan.mobile}} </td>
                            <td>{{plan.circle_name}} </td>
                            <td>{{plan.cityName}} </td>
                            <td>
                                <span *ngIf="plan.sourceName" class="badge bg-green-light">{{plan.sourceName}} </span>
                            </td>
                            <td>
                                <div *ngIf="plan.type == '2'">
                                    <span>Glamyo Health</span>
                                </div>
                            </td>
                            <td>{{plan.planName}} </td>
                            <td>
                                <span class="badge bg-azure-light">{{plan.lead_status_name}}</span>
                            </td>
                            <td>{{plan.description}} </td>
                            <td>{{plan.created_on*1000|date:'d MMM, yyyy hh:mm aa'}} </td>
                            <td>
                                <button class="btn btn-success btn-sm" (click)="openZoneDialog(plan.id)">
                                    Update Plan Lead
                                </button>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="12" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !planList.length">
                            <td colspan="12"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>